export default __webpack_public_path__ + "static/media/img-7.7d046fd9.jpg";